import React, {useState} from "react";
import styles from './Stepper.module.css';

const Step = (props) => {
    return <>
        <div className={'d-flex justify-content-start align-items-center'}>
            <div className={`${styles.circle} ${props.isActive && styles.activeLabel}`}>
                {props.label}
            </div>
            <span className={`ms-3 ${props.isActive && styles.activeContent}`}>
                {props.content}
            </span>
        </div>
        {!props.lastStep &&
        <div className={`d-flex ${styles.verticalStep}`}>
            <div className={'vr'}/>
        </div>
        }
    </>
}

export default Step;